
import * as ipxRuntime$MMolPe6EI1 from '/home/gitlab-runner/builds/52ykkrvhr/0/nationalhorseman/nationalhorseman-laravel-8/node_modules/@nuxt/image-edge/dist/runtime/providers/ipx'
import * as customProviderRuntime$IfdVI2RMH3 from '/home/gitlab-runner/builds/52ykkrvhr/0/nationalhorseman/nationalhorseman-laravel-8/providers/S3Aws.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "horsemanarabian-dev-files.s3.us-west-1.amazonaws.com",
    "api.nationalhorsemanarabian.com"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$MMolPe6EI1, defaults: {} },
  ['customProvider']: { provider: customProviderRuntime$IfdVI2RMH3, defaults: {"baseURL":"https://horsemanarabian-dev-files.s3.us-west-1.amazonaws.com","modifiers":{"format":"WebP","width":50,"height":50}} }
}
        